module.exports = __webpack_public_path__ + "img/pipline_banner_btn.aa4a8a7c.png";